import React, { useState } from "react";
import { validateURL } from "../../../utils/validateURL";
import Modal from "../../../components/Modal";
import { GlobeAltIcon } from "@heroicons/react/24/outline";
import PrimaryLinkButton from "../../../components/PrimaryLinkButton";
import Input from "../../../components/Input";

const AddWebsiteModal = ({
  isOpen,
  onClose,
  onSuccess,
  setLoading,
  api,
  loading,
}) => {
  const [urls, setUrls] = useState([{ value: "", isValid: false }]);

  const addNewUrlField = () => {
    setUrls([...urls, { value: "", isValid: false }]);
  };

  const updateUrl = (index, value) => {
    const isValid = validateURL(value);
    const updatedUrls = [...urls];
    updatedUrls[index] = { value, isValid };
    setUrls(updatedUrls);
  };

  const removeUrlField = index => {
    const updatedUrls = urls.filter((_, i) => i !== index);
    setUrls(updatedUrls);
  };
  const handleAddSource = async e => {
    try {
      e.preventDefault();

      setLoading(true);

      let ok = 0;

      for (const url of urls) {
        await api.post("/api/process-url", { url: url.value });
        ok++;
      }

      if (ok !== urls.length) {
        return alert("Some URLs failed to process");
      }

      onSuccess();
      onClose();
    } catch (error) {
      console.error("Error processing URLs:", error);
    } finally {
      setLoading(false);
    }
  };

  const actionDisabled =
    !urls.every(url => url.isValid && url.value.length > 0) || loading;

  return (
    <Modal
      isSubmitting={loading}
      disabled={actionDisabled}
      onSubmit={handleAddSource}
      startIcon={
        <div className="p-2 rounded-xl border">
          <GlobeAltIcon className="size-6" />
        </div>
      }
      open={isOpen}
      onClose={onClose}
      title="Add Website URL(s)"
    >
      <div>
        <div className="text-xs text-gray-800 font-semibold">URL(s)</div>
        <div className="mt-2 space-y-2">
          {urls.map((url, index) => (
            <div key={index} className="flex items-center space-x-2">
              <div className="flex-1">
                <Input
                  placeholder="example.com/faq"
                  startIcon={<GlobeAltIcon className="size-6" />}
                  value={url.value}
                  onChange={e => updateUrl(index, e.target.value)}
                />
              </div>
              {index > 0 && (
                <button
                  onClick={() => removeUrlField(index)}
                  className="text-gray-400 hover:text-red-500 focus:outline-none"
                >
                  &times;
                </button>
              )}
            </div>
          ))}
        </div>

        <div className="mt-3">
          <PrimaryLinkButton onClick={addNewUrlField} type="button">
            + Add another
          </PrimaryLinkButton>
        </div>
      </div>
    </Modal>
  );
};

export default AddWebsiteModal;
